import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/**
 * Displays an error toast notification in the top-right corner.
 * @param {string} message - The error message to display.
 */
export const showErrorToast = (message) => {
  toast.error(message, {
    position: toast.POSITION.TOP_RIGHT,
  });
};

/**
 * Displays a success toast notification in the top-right corner.
 * @param {string} message - The success message to display.
 */
export const showSuccessToast = (message) => {
  toast.success(message, {
    position: toast.POSITION.TOP_RIGHT,
  });
};
